import type { DisplayStatus } from "@/lib/role-labels";

/** Badge variant for a member's DisplayStatus — mirrors the admin users-table
 * mapping (active=mint success, deactivated=rose destructive, everything else
 * a neutral outline) so the two surfaces read the same status the same way. */
export function statusBadgeVariant(
  status: DisplayStatus,
): "success" | "destructive" | "secondary" | "outline" {
  switch (status) {
    case "active":
      return "success";
    case "deactivated":
      return "destructive";
    case "pending":
      return "secondary";
    default:
      // invited / rejected / closed
      return "outline";
  }
}
